<script setup lang="ts">
import { ContactList } from "@/interfaces/Contact";
import ContactInfo from "./ContactInfo.vue";

defineProps<{ contactList: ContactList }>();
</script>

<template>
  <div class="py-2.5 contact-box">
    <div class="contact-title bg-main">
      <h3 class="text-white text-base">{{ contactList.title }}</h3>
    </div>
    <ContactInfo
      v-for="contact in contactList.contacts"
      :key="contact.name"
      :contact="contact"
    />
  </div>
</template>

<style>
.contact-title {
  height: 55px;
  padding: 15px 25px;
  margin-bottom: 15px;
}

.contact-box > div:last-child .contact-info {
  border: none;
}
</style>
